// extracted by mini-css-extract-plugin
export default {"imagen-responsive":"styles_imagen-responsive__yWnZ6"};